import { useTranslation } from 'react-i18next';
import { getCantonByCode, getCantonName } from '../../utils/cantonData';
import styles from './OrgFlag.module.css';

interface OrgFlagProps {
  level: 'federal' | 'canton' | 'commune';
  code: string;
  size?: 'sm' | 'md' | 'lg';
}

const SIZES = { sm: 20, md: 28, lg: 36 } as const;

export function OrgFlag({ level, code, size = 'md' }: OrgFlagProps) {
  const { i18n } = useTranslation();
  const px = SIZES[size];

  if (level === 'federal') {
    const crossW = Math.round(px * 0.2);
    const crossH = Math.round(px * 0.6);
    const offset = Math.round((px - crossH) / 2);
    const mid = Math.round((px - crossW) / 2);
    return (
      <span className={`${styles.flag} ${styles.federal} ${styles[size]}`} title="Switzerland">
        <svg width={px} height={px} viewBox={`0 0 ${px} ${px}`}>
          <rect x={mid} y={offset} width={crossW} height={crossH} fill="#fff" />
          <rect x={offset} y={mid} width={crossH} height={crossW} fill="#fff" />
        </svg>
      </span>
    );
  }

  if (level === 'canton') {
    const canton = getCantonByCode(code);
    const bg = canton?.primaryColor ?? '#555';
    const fg = canton?.secondaryColor ?? '#fff';
    return (
      <span
        className={`${styles.flag} ${styles.canton} ${styles[size]}`}
        style={{ background: bg, color: fg }}
        title={getCantonName(code, i18n.language)}
      >
        {code.toUpperCase().slice(0, 2)}
      </span>
    );
  }

  // commune
  return (
    <span
      className={`${styles.flag} ${styles.commune} ${styles[size]}`}
      title={code}
    >
      {code.slice(0, 2).toUpperCase()}
    </span>
  );
}
